import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { WhatsAppButton, MobileQuoteBar } from "./FloatingCTAs";
import { ChatbotWidget } from "./ChatbotWidget";

export function Layout({ children }) {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div className="min-h-screen bg-navy-900 text-white flex flex-col">
      <Header />
      <main className="flex-1 pb-20 lg:pb-0">{children}</main>
      <Footer />
      <WhatsAppButton />
      <MobileQuoteBar />
      <ChatbotWidget />
    </div>
  );
}

export default Layout;
